const imageContext = require.context(
  './images/galleryImages',
  false,
  /\.webp$/i
);

const images = imageContext.keys().map(key => ({
  src: imageContext(key),
  alt: 'Cascade Mountain Ranch wedding'
}));

export default function MyGallery() {
  return (
    <div className="gallery-grid">
      {images.map((item, i) => (
        <div key={i} className="gallery-item">
          <img
            src={item.src}
            alt={item.alt}
            loading={i < 6 ? "eager" : "lazy"}
            decoding="async"
          />
        </div>
      ))}
    </div>
  );
}
